export default "__VITE_ASSET__Dbbj65hn__"